import * as React from "react";
import ErrorWidget from "./ErrorWidget";
export default class WidgetErrorBoundary extends React.Component {
  static getDerivedStateFromError(error) {
    return { error };
  }
  constructor(props) {
    super(props);
    this.state = {};
  }
  render() {
    const { error } = this.state;
    const { children, ...rest } = this.props;
    const childrenWithProps = React.cloneElement(children, rest);
    return error ? /* @__PURE__ */ React.createElement(
      ErrorWidget,
      {
        title: "While rendering this widget, the following error occurred:",
        errors: [{ description: error.toString() }]
      }
    ) : childrenWithProps;
  }
}
